import { SortOrder } from '@Utils/helpers/sortingHelpers';
import {
    IProject,
    IProjectDocument,
    ViewProjectSortField,
} from '@Data/projects/Interfaces';

export interface IProjectState {
    projects: Array<IProject>;
    selectedProject: IProject;
    sortOrder: SortOrder;
    sortByField: ViewProjectSortField;
    selectedProjectDocuments: Array<IProjectDocument>;
}

export const initialProjectState: IProjectState = {
    projects: [],
    selectedProject: null,
    sortOrder: SortOrder.ASC,
    sortByField: ViewProjectSortField.CREATED,
    selectedProjectDocuments: null,
};
